
export default {
  fine_prints: []
}
